
/** @jsx jsx */
import React, {useEffect} from "react";
import ReactModal from "react-modal";
import { Box, jsx, Flex } from "theme-ui";
import { css, Global } from "@emotion/react";
import Icon from "./Icon";

const defaultStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    padding: '0',
    borderRadius: '5px 5px 0px 0px',
    border: "5px solid #272763",
    boxShadow: "0px 3px 6px #00000029",
    transform: "translate(-50%, -50%)",
    maxWidth: '95%',
  },
  overlay: {
    zIndex: 10000
  }
};

ReactModal.setAppElement("#___gatsby");

const HubspotFormModal = ({ closeModal, showModal, hubspotFormData }) => {
const { region, portalId, formId, classname } = hubspotFormData ?? {};
const containerId = "hubspotFormContainer";

  useEffect(() => {
    if (showModal) {
      const script = document.createElement("script");
      script.charset = "utf-8";
      script.type = "text/javascript";
      script.src = "//js.hsforms.net/forms/embed/v2.js";
      script.async = true;

      script.onload = () => {
        window.hbspt.forms.create({
          region: region,
          portalId: portalId,
          formId: formId,
          target: `#${containerId}`,
          onFormReady: function () {
            const iframe = document.querySelector(`#${containerId} iframe`);
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            const paragraphTags = iframeDocument.querySelectorAll('p');
            paragraphTags.forEach((pTag) => {
              pTag.style.fontSize = '12px';
            });
          },
        });
      };

      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [showModal, region, portalId, formId]);

  return (
    <Box sx={{display: "flex", flexDirection: "column" }}>
      <ReactModal
        isOpen={showModal}
        style={defaultStyles}
        onRequestClose={closeModal}
        portalClassName={`hbspt-modal ${classname}`}
      >
        {showModal &&
          <Global
            styles={css`
          html,
          body {
            overflow-y: hidden;
          }
          `}
          />}
        <Box sx={{ width: '100%' }}>
          <div
            onClick={closeModal}
            sx={{
              cursor: "pointer",
              fontSize: "2rem",
              fontWeight: 700,
              position: "absolute",
              top: "1rem",
              right: "1rem",
              color: "white",
              transition: "200ms",
              backgroundColor: "#272763",
              "&:hover": {
                color: "gray",
              },
            }}
          >
          <Icon
            icon='io-close'
          />
         </div>
        </Box>
        <Box sx={{ paddingX: 3, paddingTop: '50px' }}>
          <div id={containerId}></div>
        </Box>
      </ReactModal>
    </Box>
  );
};

export default HubspotFormModal;